exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".online-consult-page{\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.online-consult-page .text-div{\n\n  padding: 24px;\n  background: white;\n}\n\n.online-consult-page .img-w-100{\n\n  width: 100%;\n\n}\n\n.online-consult-page .logo{\n\n  padding: 24px;\n  background: white;\n\n}\n\n.online-consult-page .btn-begin-consult{\n\n  width: 100%;\n  padding: 20px;\n  font-size: 1.5em;\n\n}\n\n\n.online-consult-page p.fontx2{\n\n  font-size: 1.3em;\n\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/online-consult.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/statics/css/online-consult.css
// module chunks = 0